import {
  type ForManagerLocationDetail,
  getLocationsHomeAttentionRetrieveQueryOptions,
  getLocationsHomeLaterRetrieveQueryOptions,
} from "@sidegigllc/api/client";
import { getDefaultStore } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { WarmableQuery } from "routing/warmQueries";
import { safeJSONStorage } from "utils/safeStorage";
import { suspenseQuery } from "utils/suspenseQuery";

// Product decision: always send mine explicitly (default Mine), even with nothing of your own; the API fallback to All is intentionally bypassed.
export const homeMineAtom = atomWithStorage("home-mine", true, safeJSONStorage<boolean>(), { getOnInit: true });

type QueriesInput = { location: ForManagerLocationDetail };

export const attentionQuery = ({ location, mine }: QueriesInput & { mine: boolean }) =>
  suspenseQuery(getLocationsHomeAttentionRetrieveQueryOptions(location.id, { shifts_mine: mine, jobs_mine: mine }));

export const laterQuery = ({ location }: QueriesInput) =>
  suspenseQuery(getLocationsHomeLaterRetrieveQueryOptions(location.id));

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  attentionQuery({ ...input, mine: getDefaultStore().get(homeMineAtom) }),
  laterQuery(input),
];
